import './OkulyonetimAdminToolbar.scss';

import React from 'react';
import {Outlet} from "react-router-dom";

import {Okul} from "../../../gql/StaticTypes";

interface Props {
    okul: Okul
}
const OkulyonetimAdminToolbar: React.FC<Props> = ({ okul }) => {

    return (
        <Outlet />
    );
};

export default OkulyonetimAdminToolbar;

